module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 85300.82b4cc1b.png";